import React from 'react';

const GiftAidCancelMessage = (props) => {

  return (
    <div>
      <h1>Thanks for letting us know</h1>
      <p>
        We won’t claim Gift Aid for your donation
      </p>
    </div>
  );

};

export default GiftAidCancelMessage;
